<template>
  <div class="paper-background">
    <div class="paper-banner">
      <div class="paper-container">
        <div class="paper-banner-title">更新日志</div>
      </div>

      <img class="paper-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="paper-container">

     <div class="paper-content">
       <div class="paper-content-title">
         <div class="paper-content-title-text">更新日志</div>
       </div>

       <div class="paper-content-info">

         <table class="paper-table">
           <tr class="paper-th">
             <th class="paper-text-th">发布时间</th>
             <th class="paper-text-th">更新简介</th>
           </tr>
           <tr class="paper-td" v-for="log in logs">
             <td class="paper-text-td">{{log.time}}</td>
             <td class="paper-text-td">{{log.summary}}</td>
           </tr>
         </table>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "LogPage",
    data() {
      return {
      }
    },
    computed: {
      ...mapState({
        logs: state => state.Log.logs.info,
      })
    },
    created(){
      this.$store.dispatch('getLogs').then(res => {
      })
    },
    methods:{

    }
  }
</script>

<style scoped>
  .paper-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .paper-background{
    margin-top: 70px;
  }
  .paper-banner{
    overflow:hidden;
  }
  .paper-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .paper-banner-img{
    min-width:100%;
    height:165px;
  }
  .paper-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .paper-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .paper-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .paper-content-info{
    margin-top: 50px;
  }
  .paper-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .paper-content-info{
    margin-top: 40px;
  }
  .paper-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .paper-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .paper-td{
    height: 45px;
  }
  .paper-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .paper-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding:4px 8px;
  }
  .paper-a{
    color:rgba(73,145,201,1)!important;
    cursor: pointer;
  }
  @media screen and (max-width:482px) {
    .paper-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .paper-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .paper-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .paper-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .paper-container{
      max-width: 1068px;
    }
  }

</style>